<script lang="ts">
    import type { OrganizationInviteData } from "@anyways-open/identity-api-client/dist/data/OrganizationInviteData";
    import {
        Alert,
        Button,
        Col,
        Container,
        Modal,
        ModalBody,
        ModalFooter,
        ModalHeader,
        Row,
    } from "sveltestrap";
    import { appManager } from "../../AppManagerStore";
    import { ModalHook } from "../../modals/ModalHook";

    // input is organization id, output is invite id. 
    let hook: ModalHook<string, OrganizationInviteData> = new ModalHook<string, OrganizationInviteData>();
    $appManager.ModalHooks.InviteUserModal = hook;
    
    let open = false;

    // hook events.
    hook.on("open", () => {
        open = true;

        organizationId = hook.getData();
    });
    hook.on("close", () => {
        open = false;
    });

    const close = () => {
        hook.close(undefined);
    };

    let organizationId = "";
    let email: string = "";
    
    let creating = false;
    let error = "";

    const save = async () => {
        error = "";
        if (email.trim().length === 0) {
            error = "Email not set";
            return;
        }

        creating = true;

        const accessToken = await $appManager.Authenticator.getAccessToken();
        const result = await $appManager.IdentityApi.postInvite({
            accessToken: accessToken,
            email: email,
            organizationId: organizationId,
            url: `${$appManager.PublicUrl}organizations/invite/accept`
        });

        creating = false;

        if (result) {
            hook.close(result);
        } else {
            error = "Could not create organization";
            hook.close(undefined);
        }
    };
</script>

<Modal isOpen={open} toggle={close}>
    <ModalHeader toggle={close}>New organization</ModalHeader>
    <ModalBody>
        <Container class="d-flex flex-column">
            <Row class="align-items-center justify-content-center gx-0">
                <Col>
                    {#if !creating}
                        <div class="mb-6">
                            <div class="form-group">
                                <label class="form-label" for="name">
                                    Email
                                </label>
                                <input
                                    type="email"
                                    class="form-control"
                                    id="email"
                                    placeholder="name@domain.com"
                                    bind:value={email} />
                            </div>

                            {#if error.length > 0}
                                <Alert class="mt-2">{error}</Alert>
                            {/if}
                        </div>
                    {:else}
                        <h1 class="mb-0 fw-bold">Success! 👍</h1>

                        <p class="mb-6 text-muted">
                            We've sent out the invite to {email}.
                        </p>
                    {/if}
                </Col>
            </Row>
        </Container>
    </ModalBody>
    <ModalFooter>
        <Button color="primary" on:click={async () => await save()}
            >Save</Button>
        <Button color="secondary" on:click={close}>Cancel</Button>
    </ModalFooter>
</Modal>
